/*
============================================
CLUSTER A/B TEST: Homepage Collection Scroller Layout
Selector target: #shopify-section-1619826415e463e264
============================================
*/
(function() {
  var TEST_ID = 'bf8e2a5d-6961-46d4-8e6b-3b80a907433b';
  var CONTROL_VARIANT_ID = 'ea8453ab-4c2b-4787-ae22-dbdcc149dde6';
  var TREATMENT_VARIANT_ID = '206792b2-303f-468f-860d-15833852edef';

  var TARGET_SECTION_SELECTOR = '#shopify-section-1619826415e463e264';
  var WHAT_WE_DO_SECTION_SELECTOR = '#shopify-section-1637098712c4c25e91';
  var TARGET_MARKER_SELECTOR = 'section[data-cluster-homepage-scroller="1"]';
  var MOBILE_MEDIA_QUERY = '(max-width: 798px)';
  var TREATMENT_CLASS = 'is-homepage-scroller-treatment';
  var TARGET_SECTION_CLASS = 'cluster-homepage-scroller-target';
  var STYLE_ID = 'cluster-homepage-scroller-treatment-style';
  var STORED_VARIANT_KEY = 'cluster_variant_' + TEST_ID;
  var SCRIPT_ASSET_NAME = 'cluster-homepage-collection-scroller-test.js';
  var VARIANT_RESOLVE_TIMEOUT_MS = 1800;
  var VARIANT_STORE_POLL_MAX_MS = 12000;
  var VARIANT_POLL_INTERVAL_MS = 200;

  var currentVariant = 'control';
  var domReady = document.readyState !== 'loading';
  var stabilizeTimers = [];
  var layoutObserver = null;
  var variantLocked = false;
  var placementState = {
    target: null,
    whatWeDo: null
  };
  var cachedThemeAssetBaseUrl = null;

  function getAssignments() {
    if (window.cluster_ctx && Array.isArray(window.cluster_ctx.assignments)) {
      return window.cluster_ctx.assignments;
    }
    if (window.__clusterDebug && Array.isArray(window.__clusterDebug.assignments)) {
      return window.__clusterDebug.assignments;
    }
    return null;
  }

  function getScriptElement() {
    if (
      document.currentScript &&
      typeof document.currentScript.getAttribute === 'function' &&
      (document.currentScript.getAttribute('src') || '').indexOf(SCRIPT_ASSET_NAME) !== -1
    ) {
      return document.currentScript;
    }

    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length - 1; i >= 0; i--) {
      var src = scripts[i].getAttribute('src') || '';
      if (src.indexOf(SCRIPT_ASSET_NAME) !== -1) {
        return scripts[i];
      }
    }

    return null;
  }

  function getThemeAssetBaseUrl() {
    if (cachedThemeAssetBaseUrl) return cachedThemeAssetBaseUrl;

    var script = getScriptElement();
    if (!script) return null;

    var scriptSrc = script.getAttribute('src');
    if (!scriptSrc) return null;

    try {
      var scriptUrl = new URL(scriptSrc, window.location.href);
      scriptUrl.search = '';
      scriptUrl.hash = '';
      scriptUrl.pathname = scriptUrl.pathname.replace(/[^/]+$/, '');
      cachedThemeAssetBaseUrl = scriptUrl.toString();
      return cachedThemeAssetBaseUrl;
    } catch (error) {
      return null;
    }
  }

  function getCollectionBadgeAssetUrl(collectionHandle) {
    if (!collectionHandle || !/\-badge$/.test(collectionHandle)) return null;

    var baseUrl = getThemeAssetBaseUrl();
    if (!baseUrl) return null;

    try {
      return new URL(collectionHandle + '.png', baseUrl).toString();
    } catch (error) {
      return null;
    }
  }

  function getAssignedVariant() {
    var assignments = getAssignments();
    if (!assignments) return null;

    for (var i = 0; i < assignments.length; i++) {
      var assignment = assignments[i];
      if (!assignment || assignment.testId !== TEST_ID) continue;

      if (assignment.variantId === TREATMENT_VARIANT_ID) return 'treatment';
      if (assignment.variantId === CONTROL_VARIANT_ID) return 'control';

      if (assignment.variant && typeof assignment.variant.isControl === 'boolean') {
        return assignment.variant.isControl ? 'control' : 'treatment';
      }
    }

    return null;
  }

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  }

  function getStoredVariant() {
    try {
      var stored = window.sessionStorage.getItem(STORED_VARIANT_KEY);
      if (stored === 'control' || stored === 'treatment') return stored;
    } catch (error) {}
    return null;
  }

  function storeVariant(variant) {
    if (variant !== 'control' && variant !== 'treatment') return;
    try {
      window.sessionStorage.setItem(STORED_VARIANT_KEY, variant);
    } catch (error) {}
  }

  function getHomepageContainer() {
    return (
      document.querySelector('main.index-sections') ||
      document.querySelector('main[data-check-for-order].index-sections') ||
      document.querySelector('.index-sections')
    );
  }

  function getHomepageSections() {
    var container = getHomepageContainer();
    if (!container) return [];

    var sections = [];
    for (var i = 0; i < container.children.length; i++) {
      var child = container.children[i];
      if (!child || child.nodeType !== 1) continue;
      sections.push(child);
    }
    return sections;
  }

  function findSection(matcher) {
    var sections = getHomepageSections();
    for (var i = 0; i < sections.length; i++) {
      if (matcher(sections[i])) return sections[i];
    }

    var fallbackSections = document.querySelectorAll('[id^="shopify-section-"]');
    for (var j = 0; j < fallbackSections.length; j++) {
      if (matcher(fallbackSections[j])) return fallbackSections[j];
    }

    return null;
  }

  function getTargetSection() {
    var explicitTarget = document.querySelector(TARGET_SECTION_SELECTOR);
    if (explicitTarget) {
      return explicitTarget;
    }

    var markedSections = document.querySelectorAll('[id^="shopify-section-"] > ' + TARGET_MARKER_SELECTOR);
    if (markedSections.length !== 1) return null;

    return markedSections[0].closest('[id^="shopify-section-"]');
  }

  function getWhatWeDoSection() {
    var explicitWhatWeDo = document.querySelector(WHAT_WE_DO_SECTION_SELECTOR);
    if (explicitWhatWeDo) return explicitWhatWeDo;

    var section = findSection(function(item) {
      return !!item.querySelector('a.banner--full-link[href*="what-we-do"]');
    });
    if (section) return section;

    return findSection(function(item) {
      return !!item.querySelector('.image-with-text-overlay img[src*="what_we_do"]');
    });
  }

  function rememberPlacement(key, section) {
    if (!section || !section.parentNode || placementState[key]) return;
    placementState[key] = {
      parent: section.parentNode,
      previousSibling: section.previousElementSibling,
      nextSibling: section.nextElementSibling
    };
  }

  function restorePlacement(key, section) {
    var state = placementState[key];
    if (!state || !section || !state.parent) return;

    if (state.previousSibling && state.previousSibling.parentNode === state.parent) {
      var insertAfterPrevious = state.previousSibling.nextElementSibling;
      if (insertAfterPrevious !== section) {
        state.parent.insertBefore(section, insertAfterPrevious);
      }
      return;
    }

    if (state.nextSibling && state.nextSibling.parentNode === state.parent) {
      if (state.nextSibling !== section) {
        state.parent.insertBefore(section, state.nextSibling);
      }
      return;
    }

    state.parent.appendChild(section);
  }

  function moveTargetToFirstPosition(targetSection) {
    var homepageContainer = getHomepageContainer() || targetSection.parentNode;
    if (!homepageContainer || !targetSection) return;
    if (homepageContainer.firstElementChild === targetSection) return;

    homepageContainer.insertBefore(targetSection, homepageContainer.firstElementChild);
  }

  function moveWhatWeDoBelowScroller() {
    var targetSection = getTargetSection();
    var whatWeDoSection = getWhatWeDoSection();
    if (!targetSection || !whatWeDoSection || !targetSection.parentNode) return;
    if (targetSection.parentNode !== whatWeDoSection.parentNode) return;

    rememberPlacement('whatWeDo', whatWeDoSection);

    var insertBeforeNode = targetSection.nextElementSibling;
    if (insertBeforeNode === whatWeDoSection) return;

    if (insertBeforeNode) {
      targetSection.parentNode.insertBefore(whatWeDoSection, insertBeforeNode);
      return;
    }

    targetSection.parentNode.appendChild(whatWeDoSection);
  }

  function restoreWhatWeDoPlacement() {
    var whatWeDoSection = getWhatWeDoSection();
    if (!whatWeDoSection) return;
    restorePlacement('whatWeDo', whatWeDoSection);
  }

  function ensureTreatmentStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '@media only screen and (max-width: 798px) {',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' {',
      '    padding-top: 0 !important;',
      '    padding-bottom: 0 !important;',
      '    margin-top: 0 !important;',
      '    margin-bottom: 0 !important;',
      '    background-color: #0e273e !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .hp-collection-scroller {',
      '    position: relative !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .hp-collection-scroller > .container {',
      '    position: absolute !important;',
      '    top: 50% !important;',
      '    left: 0 !important;',
      '    right: 0 !important;',
      '    transform: translateY(-50%) !important;',
      '    pointer-events: none !important;',
      '    z-index: 2 !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .featured-promotions__nav-wrapper {',
      '    display: flex !important;',
      '    justify-content: space-between !important;',
      '    width: 100% !important;',
      '    padding: 0 4px !important;',
      '    margin: 0 !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .featured-promotions__nav {',
      '    margin-bottom: 0 !important;',
      '    pointer-events: auto !important;',
      '    cursor: pointer !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .featured-promotions__nav svg {',
      '    width: 16px !important;',
      '    height: 16px !important;',
      '    fill: #ffffff !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .featured-promotions__wrapper {',
      '    padding-left: 0 !important;',
      '    padding-right: 0 !important;',
      '    margin-bottom: 0 !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .featured-promotions__wrapper.flickity-enabled {',
      '    width: 86% !important;',
      '    max-width: 330px !important;',
      '    margin-left: auto !important;',
      '    margin-right: auto !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .flickity-enabled .featured-promotions__block {',
      '    margin-left: 0 !important;',
      '    margin-right: 0 !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .featured-promotions__block {',
      '    padding-left: 0 !important;',
      '    padding-right: 0 !important;',
      '    margin-bottom: 0 !important;',
      '    display: flex !important;',
      '    flex-direction: column !important;',
      '    align-items: center !important;',
      '    background-color: #0e273e !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .featured-promotions__block.one-eighth {',
      '    width: calc(33.333% - 2px) !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .featured-promotions__content {',
      '    width: 78px !important;',
      '    max-width: 78px !important;',
      '    margin: 0 auto 4px !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .featured-promotions__content .image-element__wrap {',
      '    width: 100% !important;',
      '    max-width: 100% !important;',
      '    margin: 0 auto !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .featured-promotions__content img,',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .featured-promotions__content svg {',
      '    width: 100% !important;',
      '    max-width: 100% !important;',
      '    height: auto !important;',
      '    margin: 0 auto !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .collection-scroller-text {',
      '    font-size: 12px !important;',
      '    line-height: 1.15 !important;',
      '    white-space: normal !important;',
      '    overflow: visible !important;',
      '    text-overflow: clip !important;',
      '    word-break: break-word !important;',
      '    margin: 0 !important;',
      '    max-width: 96px !important;',
      '    padding: 0 1px !important;',
      '    color: #ffffff !important;',
      '  }',
      '  .' + TREATMENT_CLASS + ' .' + TARGET_SECTION_CLASS + ' .collection-scroller-text span {',
      '    color: #ffffff !important;',
      '  }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function clearStabilizeTimers() {
    for (var i = 0; i < stabilizeTimers.length; i++) {
      clearTimeout(stabilizeTimers[i]);
    }
    stabilizeTimers = [];
  }

  function resizeTargetFlickity(targetSection) {
    if (!targetSection) return;

    var sliders = targetSection.querySelectorAll('.featured-promotions__wrapper.flickity-enabled');
    if (!sliders.length) return;

    for (var i = 0; i < sliders.length; i++) {
      var slider = sliders[i];
      var resized = false;

      if (window.Flickity && typeof window.Flickity.data === 'function') {
        var flickityInstance = window.Flickity.data(slider);
        if (flickityInstance && typeof flickityInstance.resize === 'function') {
          flickityInstance.resize();
          if (typeof flickityInstance.reposition === 'function') {
            flickityInstance.reposition();
          }
          resized = true;
        }
      }

      if (!resized && window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.flickity === 'function') {
        try {
          window.jQuery(slider).flickity('resize');
        } catch (error) {}
      }
    }
  }

  function scheduleTreatmentStabilize() {
    clearStabilizeTimers();

    var delays = [0, 120, 360, 900];
    for (var i = 0; i < delays.length; i++) {
      stabilizeTimers.push(
        setTimeout(function() {
          if (currentVariant !== 'treatment' || !isMobileViewport()) return;
          var targetSection = getTargetSection();
          if (!targetSection) return;
          targetSection.classList.add(TARGET_SECTION_CLASS);
          moveTargetToFirstPosition(targetSection);
          resizeTargetFlickity(targetSection);
        }, delays[i])
      );
    }
  }

  function bindLayoutObserver() {
    if (layoutObserver) return;
    var container = getHomepageContainer();
    if (!container || typeof MutationObserver !== 'function') return;

    layoutObserver = new MutationObserver(function() {
      if (currentVariant === 'treatment' && isMobileViewport()) {
        scheduleTreatmentStabilize();
      }
    });

    layoutObserver.observe(container, {
      childList: true,
      subtree: true
    });
  }

  var originalImageData = [];

  function rememberOriginalImageData(img) {
    for (var i = 0; i < originalImageData.length; i++) {
      if (originalImageData[i].img === img) return originalImageData[i];
    }

    var data = {
      img: img,
      src: img.getAttribute('src'),
      srcset: img.getAttribute('srcset'),
      dataSrc: img.getAttribute('data-src'),
      dataSrcset: img.getAttribute('data-srcset')
    };

    originalImageData.push(data);
    return data;
  }

  function restoreImageAttribute(img, attributeName, value) {
    if (value === null) {
      img.removeAttribute(attributeName);
      return;
    }

    img.setAttribute(attributeName, value);
  }

function applyTreatmentLayout() {
  var targetSection = getTargetSection();
  if (!targetSection) return;

  rememberPlacement('target', targetSection);
  targetSection.classList.add(TARGET_SECTION_CLASS);
  ensureTreatmentStyles();
  moveTargetToFirstPosition(targetSection);
  document.documentElement.classList.add(TREATMENT_CLASS);

  // Swap images to transparent PNGs using stable promo index mapping
  // so it works across markets with translated collection handles
  var badgeHandlesByIndex = {
    0: 'kickstarter-exclusive-games-badge',
    1: 'available-kickstarter-games-badge',
    2: 'in-stock-kickstarter-games-badge',
    3: 'pre-order-kickstarter-games-badge',
    4: 'new-kickstarter-games-badge',
    5: 'retail-games-badge',
    6: 'in-stock-retail-games-badge',
    7: 'pre-order-retail-games-badge',
    8: 'new-retail-games-badge',
    9: 'new-kickstarter-exclusive-games-badge',
    10: 'pre-order-kickstarter-exclusive-games-badge',
    11: 'in-stock-kickstarter-exclusive-games-badge'
  };

  var blocks = targetSection.querySelectorAll('.featured-promotions__block');
  for (var i = 0; i < blocks.length; i++) {
    var block = blocks[i];
    var promoIndex = block.getAttribute('data-promo-index');
    if (promoIndex == null || !badgeHandlesByIndex.hasOwnProperty(promoIndex)) continue;

    var assetUrl = getCollectionBadgeAssetUrl(badgeHandlesByIndex[promoIndex]);
    if (!assetUrl) continue;

    var img = block.querySelector('.featured-promotions__content img');
    if (!img) continue;

    rememberOriginalImageData(img);
    img.setAttribute('src', assetUrl);
    img.setAttribute('srcset', '');
    if (img.hasAttribute('data-src')) img.setAttribute('data-src', assetUrl);
    if (img.hasAttribute('data-srcset')) img.setAttribute('data-srcset', '');
    img.classList.remove('lazyload');
    img.classList.add('lazyloaded');
  }

  scheduleTreatmentStabilize();
}

  function revertTreatmentLayout() {
    var targetSection = getTargetSection();
    if (targetSection) {
      restorePlacement('target', targetSection);
      targetSection.classList.remove(TARGET_SECTION_CLASS);
    }
    document.documentElement.classList.remove(TREATMENT_CLASS);

    // Restore original images
    for (var i = 0; i < originalImageData.length; i++) {
      var data = originalImageData[i];
      restoreImageAttribute(data.img, 'src', data.src);
      restoreImageAttribute(data.img, 'srcset', data.srcset);
      restoreImageAttribute(data.img, 'data-src', data.dataSrc);
      restoreImageAttribute(data.img, 'data-srcset', data.dataSrcset);
    }
    originalImageData = [];

    clearStabilizeTimers();
  }

  function applyVariantLayout() {
    if (!domReady) return;

    var targetSection = getTargetSection();
    if (targetSection) {
      rememberPlacement('target', targetSection);
    }

    var whatWeDoSection = getWhatWeDoSection();
    if (whatWeDoSection) {
      rememberPlacement('whatWeDo', whatWeDoSection);
    }

    var isMobile = isMobileViewport();
    var isTreatment = currentVariant === 'treatment';
    if (isTreatment && isMobile) {
      applyTreatmentLayout();
    } else {
      revertTreatmentLayout();
    }

    if (isMobile) {
      restoreWhatWeDoPlacement();
    } else if (isTreatment) {
      moveWhatWeDoBelowScroller();
    } else {
      restoreWhatWeDoPlacement();
    }
  }

  function applyVariant(variant) {
    currentVariant = variant === 'treatment' ? 'treatment' : 'control';
    applyVariantLayout();
  }

  function lockAndApplyVariant(variant) {
    if (variantLocked) return;
    variantLocked = true;
    applyVariant(variant);
  }

  function bindViewportListener() {
    if (!window.matchMedia) return;
    var mediaQueryList = window.matchMedia(MOBILE_MEDIA_QUERY);
    if (typeof mediaQueryList.addEventListener === 'function') {
      mediaQueryList.addEventListener('change', applyVariantLayout);
      return;
    }
    if (typeof mediaQueryList.addListener === 'function') {
      mediaQueryList.addListener(applyVariantLayout);
    }
  }

  if (!domReady) {
    document.addEventListener('DOMContentLoaded', function() {
      domReady = true;
      applyVariantLayout();
    });
  }

  window.addEventListener('load', function() {
    if (currentVariant === 'treatment' && isMobileViewport()) {
      scheduleTreatmentStabilize();
    }
  });

  function resolveVariantDeterministically() {
    var assignedVariant = getAssignedVariant();
    if (assignedVariant) {
      storeVariant(assignedVariant);
      lockAndApplyVariant(assignedVariant);
      return;
    }

    var storedVariant = getStoredVariant();
    if (storedVariant) {
      lockAndApplyVariant(storedVariant);
    }

    var startedAt = Date.now();
    var pollInterval = setInterval(function() {
      var liveAssignedVariant = getAssignedVariant();
      if (liveAssignedVariant) {
        storeVariant(liveAssignedVariant);
        if (!variantLocked) {
          lockAndApplyVariant(liveAssignedVariant);
        }
        clearInterval(pollInterval);
        return;
      }

      if (Date.now() - startedAt >= VARIANT_RESOLVE_TIMEOUT_MS) {
        if (!variantLocked) {
          lockAndApplyVariant('control');
        }
      }

      if (Date.now() - startedAt >= VARIANT_STORE_POLL_MAX_MS) {
        clearInterval(pollInterval);
      }
    }, VARIANT_POLL_INTERVAL_MS);
  }

  bindViewportListener();
  bindLayoutObserver();
  resolveVariantDeterministically();
})();
